import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from './markdown-service';
import { jsPDF } from 'jspdf';
 import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class SanitizationService {

  constructor(private sanitizer: DomSanitizer,
    private markdownService: MarkdownService
  ) { }
  sanitizeMessage(message: string, searchText: string = '',searchChunk=false): SafeHtml {
    if (!message) {
      return this.sanitizer.bypassSecurityTrustHtml('No Answer');
    }
  
    try {
      if (message.trim().startsWith('{') || message.trim().startsWith('[')) {
        let parsedMessage = JSON.parse(message);
        message = JSON.stringify(parsedMessage, null, 0);
      }
  
      // message = message.replace(/_/g, '\\_');
     message = message
              .replace(/\\n/g, '\n')
              .replace(/\\t/g, '\t')
              .replace(/^\s*---\s*$/gm, '');
      message = this.extractAndTransformLinks(message);
      
      // ✅ Convert Markdown to HTML
      let htmlMessage = this.markdownService.convertToHtml(message);

      if(searchChunk){
        searchText = this.markdownService.convertToHtml(searchText);
        if (searchText) {
          // strip html to get plain text
          const cleanSearch = this.cleanHtml(searchText).trim();

          if (cleanSearch) {
            // split into lines and remove empty ones
            const lines = cleanSearch.split(/\r?\n/).map(l => l.trim()).filter(l => l);

            for (const line of lines) {
              // escape regex special chars
              const escaped = line.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
              const re = new RegExp(escaped, 'gi');

              htmlMessage = htmlMessage.replace(re, match =>
                `<span class="highlight">${match}</span>`
              );
            }
          }
        }
      }
      else{
        // ✅ Highlight if search text provided
        if (searchText) {
          const escapedSearch = searchText.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
          const re = new RegExp(escapedSearch, 'gi');
          htmlMessage = htmlMessage.replace(re, match => `<span class="highlight">${match}</span>`);
        }
      }      
      return this.sanitizer.bypassSecurityTrustHtml(htmlMessage);
  
    } catch (error) {
      console.error('Error parsing message:', error);
      return this.sanitizer.bypassSecurityTrustHtml('Invalid Answer Format');
    }
  }
  
  
  
  
  
  
  

  private extractAndTransformLinks(message: string): string {
    // Use a regular expression to find image URLs in the message
    const markdownimageRegex = /!\[([^\]]*)\]\((https?:\/\/\S+\.(?:png|jpg|jpeg|gif))\)/gi; 
    const plainimageRegex = /(https?:\/\/\S+\.png)|(https?:\/\/\S+\.jpg)|(https?:\/\/\S+\.jpeg)|(https?:\/\/\S+\.gif)/gi;
    const sourceUrlRegex = /Source: (https?:\/\/\S+)/gi;
    // Split the message by <br/> tags to get individual URLs
    const urls = message.split('<br/>');

    // Process each URL separately
    const transformedParts = urls.map(part => {
      // Check if the part matches the source URL pattern
      if (sourceUrlRegex.test(part)) {
          // Replace the source URL with a clickable link
          return part.replace(sourceUrlRegex, '<a href="$1" target="_blank">Source: $1</a>');
      } else {
          // Replace Markdown image syntax with <img> tags
          const matches = part.match(markdownimageRegex); // Use the correct regex variable
          if (matches) {
              matches.forEach(match => {
                  const altTextMatch = match.match(/!\[([^\]]*)\]/); // Match to get alt text
                  const urlMatch = match.match(/https?:\/\/\S+\.(?:png|jpg|jpeg|gif)/); // Match to get the URL
  
                  const altText = altTextMatch ? altTextMatch[1] : 'Image'; // Default to "Image" if alt text is missing
                  const imageUrl = urlMatch ? urlMatch[0] : ''; // Ensure there's an image URL                  
                  // Replace Markdown image syntax with an <img> tag
                  return part.replace(match, `<br/><img src="${imageUrl}" alt="${altText}" style="max-width: 100%;"/><br/>`);
                  
              });
          }else{
              part = part.replace(plainimageRegex, (match) => {
              return `<br/><img src="${match}" alt="Image" style="max-width: 100%;"/><br/>`;
              });
              }      
          return part; // Return the modified part (or original if no images found)
      }
  });
  

    // Reconstruct the message with transformed URLs
    const transformedMessage = transformedParts.join('<br/>');

    return transformedMessage;
  }
  cleanHtml(text: string): string {
    let div = document.createElement('div');
    div.innerHTML = text;
    return div.textContent || div.innerText || '';
  }
  // downloadAnswer(answer: string | SafeHtml, format: 'pdf' | 'docx' | 'txt',Docname:string) {
  //   let content: string;
  
  //   // Convert markdown to plain text
  //   if (typeof answer === 'string') {
  //     const htmlContent = this.markdownService.convertToHtml(answer.replace(/\\n/g, '\n').replace(/\\t/g, '\t'));
  //     content = htmlContent.replace(/<\/?[^>]+(>|$)/g, "");  // Remove HTML tags to get plain text
  //   } else {
  //     content = this.sanitizer.sanitize(1, answer) || '';
  //   }
  //   switch (format) {
  //     case 'txt':
  //       // Generate and download a TXT file
  //       console.log(content);
  //       const txtBlob = new Blob([content], { type: 'text/plain' });
  //       this.downloadFile(txtBlob, Docname);
  //       break;
  
  //     case 'pdf':
  //       // Generate and download a PDF file
  //       const docPdf = new jsPDF();
  //       docPdf.text(content, 10, 10);  // Add the text to PDF
  //       docPdf.save(Docname);  // Save the PDF
  //       break;
  
  //     case 'docx':
  //       // Generate and download a DOCX file
  //       const doc = new Document({
  //         sections: [
  //             {
  //                 properties: {},
  //                 children: [
  //                     new Paragraph({
  //                         children: [
  //                             new TextRun("This is a simple text run."),
  //                             new TextRun({
  //                                 text: "This is bold text.",
  //                                 bold: true,
  //                             }),
  //                             new TextRun({
  //                                 text: "This is another text run.",
  //                                 italics: true,
  //                             }),
  //                         ],
  //                     }),
  //                 ],
  //             },
  //         ],
  //     });
  
  //       Packer.toBlob(doc).then(blob => {
  //         this.downloadFile(blob, Docname);
  //       });
  //       break;
  
  //     default:
  //       console.error('Unsupported format');
  //   }
  // }
  
  // // Helper function to download the file
  // downloadFile(blob: Blob, filename: string) {
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = filename;
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  // }
}

